// extracted by css-extract-rspack-plugin
export default {"banner":"AdvBannerStrip_banner__8aoZP","darkBlue":"AdvBannerStrip_darkBlue__lKIN1"};